/**
 * GDPR Article 12 — monthly transparency email opt-in toggle.
 *
 * Sent once per month listing every record the clinic holds about the
 * patient. Default = opt-in. Patient can flip it off any time.
 */
import React, { useEffect, useState } from 'react';
import { Mail } from 'lucide-react';
import { api } from '../../../lib/api';
import { t } from '../../../lib/i18n';

export function TransparencyPref({ locale = 'en' }) {
  const [pref, setPref] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get('/auth/me/transparency-pref').then(r => setPref(r.data)).catch(() => setPref({ opt_out: false }));
  }, []);

  if (!pref) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.post('/auth/me/transparency-pref', { opt_out: !pref.opt_out });
      setPref(p => ({ ...p, opt_out: data.opt_out }));
    } catch (e) {
      alert(e?.response?.data?.detail || e.message);
    } finally { setBusy(false); }
  };

  const lastSent = pref.last_sent_at ? new Date(pref.last_sent_at).toLocaleDateString() : 'never';
  return (
    <div className="surface border border-soft rounded-lg p-4 mt-6 max-w-xl" data-testid="transparency-pref-zone">
      <h3 className="font-heading font-semibold flex items-center gap-2 mb-1">
        <Mail className="w-4 h-4 text-brand"/> {t(locale, 'monthly_transparency_email')}
      </h3>
      <p className="text-sm text-fg-muted mb-3">{t(locale, 'monthly_transparency_lede', { last: lastSent })}</p>
      <label className="inline-flex items-center gap-2 text-sm cursor-pointer">
        <input type="checkbox" checked={!pref.opt_out} onChange={toggle} disabled={busy}
               data-testid="transparency-opt-in"/>
        <span>{t(locale, 'email_me_monthly_summary')}</span>
      </label>
    </div>
  );
}
